interface AddScriptTagOptions {
	attributes?: Record<string, string>;
	onLoad?: () => void;
	loadType?: 'async' | 'defer';
}

export function addContentToHead(element: HTMLElement, position: InsertPosition = 'beforeend') {
	if (!element) {
		return;
	}

	const head = document.getElementsByTagName('head')[0];
	head.insertAdjacentElement(position, element);
}

export function addScriptTag(
	id: string,
	src: string,
	{ attributes, onLoad, loadType = 'defer' }: AddScriptTagOptions = {},
) {
	const head = document.getElementsByTagName('head')[0];

	if (head.querySelector(`#${id}`)) {
		return;
	}

	const script = document.createElement('script');
	script.type = 'text/javascript';

	script.id = id;
	script.src = src;

	if (loadType) {
		script[loadType] = true;
	}

	if (attributes) {
		const attributesKeys = Object.keys(attributes);
		if (attributesKeys.length) {
			attributesKeys.forEach(key => script.setAttribute(key, attributes[key]));
		}
	}

	if (onLoad) {
		script.onload = onLoad;
	}

	head.appendChild(script);
}

export function addLinkTag(
	id: string,
	rel: string,
	href: string,
	as?: string,
	crossOrigin?: string,
) {
	const head = document.getElementsByTagName('head')[0];

	if (head.querySelector(`#${id}`)) {
		return;
	}

	const link = document.createElement('link');
	link.id = id;
	link.rel = rel;
	if (as) {
		link.as = as;
	}
	link.href = href;
	if (crossOrigin) {
		link.crossOrigin = crossOrigin;
	}

	head.appendChild(link);
}
